import { formatDate } from "../../../utils/formatDate";
import { Parcela } from "../types";
import { formatNumberToPtBr } from "../utils";

export const columns = [
  {
    title: "Parcela",
    key: "posicao",
    render: (row?: Parcela) => (row?.posicao ? row.posicao : ""),
  },
  {
    title: "Faturamento",
    key: "dataFaturamento",
    render: (row?: Parcela) =>
      row?.dataFaturamento ? formatDate(row?.dataFaturamento) : "",
  },
  {
    title: "Principal",
    key: "principal",
    render: (row?: Parcela) =>
      row?.principal ? formatNumberToPtBr(row.principal) : "",
  },
  {
    title: "Juros",
    key: "juros",
    render: (row?: Parcela) =>
      row?.juros ? formatNumberToPtBr(row.juros) : "",
  },
  {
    title: "IOF",
    key: "iof",
    render: (row?: Parcela) => (row?.iof ? formatNumberToPtBr(row.iof) : ""),
  },
  {
    title: "Valor total",
    key: "valor",
    render: (row?: Parcela) =>
      row?.valor ? formatNumberToPtBr(row.valor) : "",
  },
];
